<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="table-expand">
                            <el-form-item label="举报用户昵称:">
                                <span>{{ props.row.nickName }}</span>
                            </el-form-item>
                            <el-form-item label="被举报用户昵称:">
                                <span>{{ props.row.toNickName }}</span>
                            </el-form-item>
                            <el-form-item label="标题:">
                                <span>{{ props.row.title }}</span>
                            </el-form-item>
                            <el-form-item label="原因:">
                                <span>{{ props.row.description }}</span>
                            </el-form-item>
                            <el-form-item label="举报图片:">
                                <el-image
                                style="width: 100px; height: 100px"
                                :src="item"
                                :preview-src-list="[item]"
                                :fit="cover" v-for="(item,index) in props.row.pathList" :key="index"></el-image>
                            </el-form-item>
                            <el-form-item label="处理结果:">
                                <span>{{ props.row.chuLi?'已处理':'未处理' }}({{ props.row.chuliResult }})</span>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="phone" label="举报用户账号" align="center"></el-table-column>
                <el-table-column prop="nickName" label="举报用户昵称" align="center"></el-table-column>
                <el-table-column prop="toNickName" label="被举报用户昵称" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.toNickName}}{{scope.row.isJUser?'(*)':''}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="toPhone" label="被举报用户账号" align="center">
                </el-table-column>
                <el-table-column prop="toWeChat" label="被举报用户微信" align="center">
                </el-table-column>
                <el-table-column prop="title" label="标题" align="center"></el-table-column>
                <el-table-column prop="description" label="原因" align="center"></el-table-column>
                <el-table-column
                prop="enable"
                label="账号状态"
                align="center"
                >
                <template slot-scope="scope">
                    {{ scope.row.enable==-3?'拉黑':'' }}
                    {{ scope.row.enable==-2?'注销':'' }}
                    {{ scope.row.enable==-1?'冻结':'' }}
                    {{ scope.row.enable==0?'审核中':'' }}
                    {{ scope.row.enable==1?'正常':'' }}
                </template>
                </el-table-column>

                <el-table-column
                prop="isChuli"
                label="操作状态"
                align="center"
                >
                <template slot-scope="scope">
                    {{ scope.row.isChuli?'已处理':'未处理' }}
                    {{ scope.row.chuliResult?'('+scope.row.chuliResult+')':'' }}
                </template>
                </el-table-column>
                <el-table-column prop="creationTime" label="创建时间" align="center" width="160px"></el-table-column>
                <el-table-column prop="" label="操作" align="center" width="160px">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="updateTip(scope.row)">点击处理</el-button>
                    </template>
                </el-table-column>
               
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="处理" width="640px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        处理情况
                    </div>
                    <div class="value">
                        <el-select v-model="updateData.type" placeholder="请选择">
                            <el-option
                            v-for="item in resultList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-button type="primary" icon="el-icon-edit" @click="update()">确认</el-button>
                </div>
                <div class="item">
                    <div class="label">
                        原因
                    </div>
                    <div class="value" style="width:400px">
                        <el-input v-model="updateData.chuliResult" placeholder="" type="textarea"></el-input>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {wtlxList,isNewList} from '../../../assets/selectList/index'
import {parseTimeS} from '../../../utils/index'
export default {
    name: 'person',
    components:{
        queryCondition,
        forms
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,
            selectRow:{},
            updateData:{
                id:null,
                reason:'',
                userId:null,
                toUserId:null,
                type: 3
            },
            totalCount:0,
            tableData:[],

            conditionData:{
                Keyword:'',
                Title:'',
                current:1,
                size:10,
            },
            queryList:[
                {type: "input",label: "综合查询:",name: "Keyword"},
                {type: "input",label: "标题:",name: "Title"},
            ],
            resultList:[
                // {
                //     label:'将举报用户微信号换手机号',
                //     value:1,
                // },
                // {
                //     label:'删除用户',
                //     value:2,
                // },
                {
                    label:'冻结用户',
                    value:3,
                },
                {
                    label:'不予理会',
                    value:0,
                },
                {
                    label:'拉黑',
                    value:4,
                }
            ]
           
        }
    },
    created(){
    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let keywords = ['假', '诈骗', '不良', '商号', '机器人', '测试'];
            let res  = await api.NmJuBaoPager(this.conditionData);
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
            for(let i in this.tableData){
                if(this.containsKeyword(this.tableData[i].description, keywords)){
                    this.tableData[i].description = ''
                }
            }
        },
        containsKeyword(str, keywords) {
            return keywords.some(keyword => str.includes(keyword));
        },
        // 删除提示
        updateTip(row){
            this.selectRow = row;
            this.updateData = {
                id:row.id,
                chuliResult:'',
                isChuli:true,
            }
            this.isUpdateDialog = true;
            console.log(this.selectRow);
        },
        async update(){
            console.log(this.updateData);
            console.log(this.updateData.type);
            if(this.updateData.type == 3){
                await this.dongjie({
                    "userId": this.selectRow.toUserId,
                    "reason": this.updateData.chuliResult
                });
            }else if(this.updateData.type == 4){
                await this.LaHei({
                    userId:this.selectRow.toUserId,
                    phone: this.selectRow.toPhone,
                    nickName: this.selectRow.toNickName,
                    weChat: this.selectRow.toWeChat,
                    reason:this.updateData.chuliResult,
                });
            }
            let res = await api.NmJuBaoChulijb(this.updateData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '已处理完成'
                });
                this.isUpdateDialog = false;
                // if(this.updateData.chuliResult == '冻结用户'){
                //     console.log(this.updateData.chuliResult);
                //     this.dongjie(this.updateData.toUserId);
                // }else if(this.updateData.chuliResult == '直接删除用户'){
                //     console.log(this.updateData.chuliResult);
                //     this.deleteItem(this.updateData.toUserId);
                // }
                // else if(this.updateData.chuliResult == '将举报用户微信号换手机号'){
                //     console.log(this.updateData.chuliResult);
                //     this.editDataFun(this.updateData.toUserId,this.updateData.weChat);
                // }
                this.loadingData();
            }
        },

        async dongjie(data){
            let res = await api.AdminStandFrozen(data);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '冻结成功!'
                });
                this.isUpdateDialog =false;
                this.loadingData();
            }
        },

        async LaHei(data){
            let res = await api.LaHei(data);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '拉黑成功'
                }); 
                this.isUpdateDialog = false;
                this.loadingData();
            }
        },

        
        async deleteItem(userId){
            let res = await api.deleteUser(userId);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });   
            }
        },
        async editDataFun(userId,weChat){
            let res = await api.AdminStandUpdateUserInfo({
                weChat:weChat,
                userId:userId
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功'
                });   
                this.loadingData();
            }
        },
        // 查询
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                Keyword:'',
                Title:'',
                current:1,
                size:10,
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        
      
        
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        
    }
    ::v-deep .table-expand {
        font-size: 0;
    }
    .row{
        display: flex;
    }
    ::v-deep .table-expand label {
        width: 200px;
        padding-left: 50px;
        color: #99a9bf;
    }
    ::v-deep .table-expand span {
        color: #222222;
    }
    ::v-deep .table-expand .btn span{
        color: #409eff;
    }
    ::v-deep .table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 100%;
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        // overflow: scroll;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 120px;
                margin-bottom: 5px;
            }
            .input{
                width: 215px;
                display: flex;
            }
            .value{
                width: 250px;
            }
        }
        .picList{
            display: flex;
            flex-wrap: wrap;
            .pic{
                position: relative;
                margin: 5px;
                width: 100px;
                height: 100px;
                .pic-edit{
                    position: absolute;
                    z-index: 10;
                    top: 0;
                    right: 0;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: rgba(0, 0, 0 , 0.6);
                    cursor: pointer;
                    i{
                        color: #ffffff;
                    }
                    .error{
                        color: #f56c6c;
                    }
                    .success{
                        color: #a9ffa9;
                    }
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            flex-direction: row-reverse;
            .el-button{
                margin-right: 10px;
            }
        }
    }
</style>
